module.exports = __webpack_public_path__ + "img/gallery-img-8.cbb8a04c.jpg";